export const facebookLikeButtonSpec = {
  content: '',
  group: 'block',
  marks: '',
  atom: true,
  attrs: {
    type: {
      default: 'facebookLikeButton'
    },
    url: {
      default: ''
    }
  },
  toDOM() {
    return ['div'];
  }
};